import { HvacGroup, INTEGER, HVAC_AREA } from '@belimo-retrofit-portal/logic';
import * as D from 'io-ts/Decoder';
import { EMPTY } from 'src/modules/common/codecs/Empty';
import { NON_EMPTY_STRING } from 'src/modules/common/codecs/NonEmptyString';
import {
  ConfigSchema,
  ConfigSchemaFile,
  ConfigSchemaGroup,
  ConfigSchemaRule,
} from 'src/modules/config/types/ConfigSchema';

const CONFIG_SCHEMA_FILE: D.Decoder<unknown, ConfigSchemaFile> = D.struct({
  fileName: NON_EMPTY_STRING,
  zIndex: INTEGER,
});

const CONFIG_SCHEMA_RULE: D.Decoder<unknown, ConfigSchemaRule> = D.lazy('ConfigSchemaRule', () => D.struct({
  area: HVAC_AREA,
  section: NON_EMPTY_STRING,
  answer: NON_EMPTY_STRING,

  layers: D.array(NON_EMPTY_STRING),
  replaces: D.union(EMPTY, D.record(NON_EMPTY_STRING)),
  rules: D.union(EMPTY, D.array(CONFIG_SCHEMA_RULE)),
}));

const CONFIG_SCHEMA_GROUP: D.Decoder<unknown, ConfigSchemaGroup> = D.struct({
  files: D.array(CONFIG_SCHEMA_FILE),
  rules: D.array(CONFIG_SCHEMA_RULE),
});

export const CONFIG_SCHEMA: D.Decoder<unknown, ConfigSchema> = D.struct({
  [HvacGroup.EMISSION]: CONFIG_SCHEMA_GROUP,
  [HvacGroup.DISTRIBUTION]: CONFIG_SCHEMA_GROUP,
  [HvacGroup.GENERATION]: CONFIG_SCHEMA_GROUP,
  [HvacGroup.AIR_HANDLER]: CONFIG_SCHEMA_GROUP,
});
